"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _ = require(".");

var _luxon = require("luxon");

var PracticeInventoryType =
/** @class */
function () {
  function PracticeInventoryType() {
    this.id = null;
    this.practiceId = null;
    this.inventoryTypeId = null;
    this.inventoryType = null;
    this.count = null;
    this.orderQuantity = null;
    this.orderTriggerNumber = null;
    this.lastNotifiedTimestamp = null;
  }

  PracticeInventoryType.thaw = function (practiceInventoryTypeObj) {
    var _a;

    if (practiceInventoryTypeObj == null) return null;
    var practiceInventoryType = new PracticeInventoryType();

    if (practiceInventoryTypeObj.id != null) {
      practiceInventoryType.setId(practiceInventoryTypeObj.id);
    }

    if (practiceInventoryTypeObj.practiceId != null) {
      practiceInventoryType.setPracticeId(practiceInventoryTypeObj.practiceId);
    }

    if (practiceInventoryTypeObj.inventoryTypeId != null) {
      practiceInventoryType.setInventoryTypeId(practiceInventoryTypeObj.inventoryTypeId);
    }

    if (practiceInventoryTypeObj.inventoryType != null) {
      practiceInventoryType.setInventoryType(_.InventoryType.thaw(practiceInventoryTypeObj.inventoryType));
    }

    if (practiceInventoryTypeObj.count != null) {
      practiceInventoryType.setCount(practiceInventoryTypeObj.count);
    }

    if (practiceInventoryTypeObj.orderQuantity != null) {
      practiceInventoryType.setOrderQuantity(practiceInventoryTypeObj.orderQuantity);
    }

    if (practiceInventoryTypeObj.orderTriggerNumber != null) {
      practiceInventoryType.setOrderTriggerNumber(practiceInventoryTypeObj.orderTriggerNumber);
    }

    if (practiceInventoryTypeObj.lastNotifiedTimestamp != null) {
      practiceInventoryType.setLastNotifiedTimestamp((_a = _luxon.DateTime === null || _luxon.DateTime === void 0 ? void 0 : _luxon.DateTime.fromISO(practiceInventoryTypeObj.lastNotifiedTimestamp)) !== null && _a !== void 0 ? _a : null);
    }

    return practiceInventoryType;
  };

  PracticeInventoryType.thawList = function (practiceInventoryTypeObjList) {
    if (practiceInventoryTypeObjList == null) {
      return [];
    }

    var practiceInventoryTypes = [];

    for (var i = 0; i < practiceInventoryTypeObjList.length; i++) {
      practiceInventoryTypes.push(PracticeInventoryType.thaw(practiceInventoryTypeObjList[i]));
    }

    return practiceInventoryTypes;
  };

  PracticeInventoryType.freeze = function (practiceInventoryType) {
    var _a, _b;

    if (practiceInventoryType == null) {
      return null;
    }

    var practiceInventoryTypeObj = {};

    if (practiceInventoryType.getId() != null) {
      practiceInventoryTypeObj.id = practiceInventoryType.getId();
    }

    if (practiceInventoryType.getPracticeId() != null) {
      practiceInventoryTypeObj.practiceId = practiceInventoryType.getPracticeId();
    }

    if (practiceInventoryType.getInventoryTypeId() != null) {
      practiceInventoryTypeObj.inventoryTypeId = practiceInventoryType.getInventoryTypeId();
    }

    if (practiceInventoryType.getInventoryType() != null) {
      practiceInventoryTypeObj.inventoryType = _.InventoryType.freeze(practiceInventoryType.getInventoryType());
    }

    if (practiceInventoryType.getCount() != null) {
      practiceInventoryTypeObj.count = practiceInventoryType.getCount();
    }

    if (practiceInventoryType.getOrderQuantity() != null) {
      practiceInventoryTypeObj.orderQuantity = practiceInventoryType.getOrderQuantity();
    }

    if (practiceInventoryType.getOrderTriggerNumber() != null) {
      practiceInventoryTypeObj.orderTriggerNumber = practiceInventoryType.getOrderTriggerNumber();
    }

    if (practiceInventoryType.getLastNotifiedTimestamp() != null) {
      practiceInventoryTypeObj.lastNotifiedTimestamp = (_b = (_a = practiceInventoryType.getLastNotifiedTimestamp()) === null || _a === void 0 ? void 0 : _a.toISO()) !== null && _b !== void 0 ? _b : null;
    }

    return practiceInventoryTypeObj;
  };

  PracticeInventoryType.freezeList = function (practiceInventoryTypes) {
    if (practiceInventoryTypes == null) {
      return [];
    }

    var practiceInventoryTypeObjList = [];

    for (var i = 0; i < practiceInventoryTypes.length; i++) {
      practiceInventoryTypeObjList.push(PracticeInventoryType.freeze(practiceInventoryTypes[i]));
    }

    return practiceInventoryTypeObjList;
  };
  /* -------------------------
     -------------------------
     -------- SETTERS --------
     -------------------------
     ------------------------- */


  PracticeInventoryType.prototype.setId = function (id) {
    this.id = id;
  };

  PracticeInventoryType.prototype.setPracticeId = function (practiceId) {
    this.practiceId = practiceId;
  };

  PracticeInventoryType.prototype.setInventoryTypeId = function (inventoryTypeId) {
    this.inventoryTypeId = inventoryTypeId;
  };

  PracticeInventoryType.prototype.setInventoryType = function (inventoryType) {
    this.inventoryType = inventoryType;
  };

  PracticeInventoryType.prototype.setCount = function (count) {
    this.count = count;
  };

  PracticeInventoryType.prototype.setOrderQuantity = function (orderQuantity) {
    this.orderQuantity = orderQuantity;
  };

  PracticeInventoryType.prototype.setOrderTriggerNumber = function (orderTriggerNumber) {
    this.orderTriggerNumber = orderTriggerNumber;
  };

  PracticeInventoryType.prototype.setLastNotifiedTimestamp = function (lastNotifiedTimestamp) {
    this.lastNotifiedTimestamp = lastNotifiedTimestamp;
  };
  /* -------------------------
     -------------------------
     -------- GETTERS --------
     -------------------------
     ------------------------- */


  PracticeInventoryType.prototype.getId = function () {
    return this.id;
  };

  PracticeInventoryType.prototype.getPracticeId = function () {
    return this.practiceId;
  };

  PracticeInventoryType.prototype.getInventoryTypeId = function () {
    return this.inventoryTypeId;
  };

  PracticeInventoryType.prototype.getInventoryType = function () {
    return this.inventoryType;
  };

  PracticeInventoryType.prototype.getCount = function () {
    return this.count;
  };

  PracticeInventoryType.prototype.getOrderQuantity = function () {
    return this.orderQuantity;
  };

  PracticeInventoryType.prototype.getOrderTriggerNumber = function () {
    return this.orderTriggerNumber;
  };

  PracticeInventoryType.prototype.getLastNotifiedTimestamp = function () {
    return this.lastNotifiedTimestamp;
  };

  return PracticeInventoryType;
}();

var _default = PracticeInventoryType;
exports.default = _default;